

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ReimbursementsSetup } from "../../components/ReimbursementsSetup/ReimbursementsSetup";


export const ReimbursementsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Reimbursements Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Reimbursements", navigateTo: "/company/reimbursements/list" },
        { text: "Create Reimbursements", navigateTo: "/company/reimbursements/setup" }
      ]}
      mainContents={<ReimbursementsSetup />}
    />
  );
};
